module.exports = __webpack_public_path__ + "img/horizontal_4_7_8023.51741de0.png";